export default {
    en: {
        id: 'exercise5',
        title: 'We need to determine whether to manage freight internally',
        titles: ['Build a model of the cost structure if we do it internally', 'Determine cost/service differences of doing it externally', 'Document the differences'],
        boxes: [
            {
                name: 'box1',
                title: 'Time',
            },
            {
                name: 'box2',
                title: 'Structure',
            },
            {
                name: 'box3',
                title: 'Degree',
            }
        ],
        correctAnswers: {
            box1: true,
            box2: false,
            box3: false
        },
        userAnswers: {
            box1: false,
            box2: false,
            box3: false
        },
        text: 'Time order, again based on visualizing a cause-effect process.  You build the model, assess the differences, and then document them, so that you can determine whether to manage freight internally.'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/6/identifyingLogicaOrder/i18n/exercise5.js